module.exports = __webpack_public_path__ + "static/img/6.319c009.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/8/sp/6.png
// module id = ZaMj
// module chunks = 0